import { Form, Button, Col, Row, InputGroup, Alert, Spinner, Modal } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useState, useEffect } from 'react';
import InfoTooltip from '../../core/ToolTip';
import { FaInfoCircle } from 'react-icons/fa';
import axios from "axios";

import { Link, useParams, useSearchParams } from "react-router-dom";
import { SpinnerModal, generateYears, getFiscalYear } from '../Util';


export default function Visitation() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_PUT = process.env.REACT_APP_VISITATION_PUT;
    const VISITATION_POST = process.env.REACT_APP_VISITATION_POST;
    const VISITATION_GET_ID = process.env.REACT_APP_VISITATION_GET_ID;

    const years = generateYears(2020, new Date().getFullYear());
    const [userName, setUserName] = useState(null);
    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const { firstName, lastName, role } = JSON.parse(storedUser);
            setUserName(`${firstName} ${lastName}`.toUpperCase());
            setUserRole(role);
        }
    }, []);



    const data = {
        type: "VISITATION",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        visitation: {
            totalVisitation: 0,
            paid: {
                generalVisitors: "",
                schoolVisitors: "",
                outOfStateVisitors: "",
                paidOutreachOffsiteVirtual: "",
                totalPaid: 0
            },
            unpaid: {
                complimentary: "",
                recreational: "",
                otherNonTicketed: "",
                outreachOffsiteVirtual: "",
                totalUnpaid: 0
            }
        },
        revenue: {
            totalVisitationRevenue: "",
            phmcTotalRevenue: "",
            phmcAdmissionShare: "",
            phmcAdmissionSharePercent: "",
            associateAdmissionShare: "",
            associateAdmissionSharePercent: "",
            totalAdmissionsRevenue: ""
        },
        combo: {
            tixSold: "",
            tixRecv: "",
            tixIncome: ""
        },
        eventsAdmissions: {
            visitorsPaid: "",
            visitorsUnPaid: "",
            totalEventRevenue: ""
        },
        remarks: "",
        acknowledge: false
    }


    const [formData, setFormData] = useState(data);
    const [showValidationError, setShowValidationError] = useState(false);
    // Show , Hide alert after save/submit
    const [show, setShow] = useState(false);
    const [successId, setSuccessId] = useState('');
    // Alert message after save/submit
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pagePath, setPagePath] = useState('');

    let { id } = useParams();
    useEffect(() => {
        const recordId = id;
        console.log(recordId);
        if (recordId) {
            setSpinnerShow(true);
            const url = VISITATION_BASE_URL + recordId + VISITATION_GET_ID;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    setFormData(data);
                    setSpinnerShow(false);
                })
        }
    }, []);

    // Check Partner Property based on drop down selection
    const [isPartnerProperty, setPartnerProperty] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        //show/hide RR Combo if railroad selected
        if (value == 'RAILROAD MUSEUM') {
            setPartnerProperty(true);
        } else {
            setPartnerProperty(false);
        }


        const [group, ...keys] = name.split('.');
        if (keys.length >= 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];

            keys.forEach((key, index) => {
                if (index === keys.length - 1) {

                    // Allow only 2 decimal values
                    const re = /^\d+(\.\d{0,2})?$/;
                    if (value === '' || re.test(value)) {
                        currentLevel[key] = value;
                    }

                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }
                if (key === "generalVisitors" || key === "schoolVisitors" || key === "outOfStateVisitors" || key === "paidOutreachOffsiteVirtual") {
                    const general = parseFloat(formData.visitation.paid.generalVisitors) || 0;
                    const school = parseFloat(formData.visitation.paid.schoolVisitors) || 0;
                    const outOfState = parseFloat(formData.visitation.paid.outOfStateVisitors) || 0;
                    const paidOutreachOffsiteVirtual = parseFloat(formData.visitation.paid.paidOutreachOffsiteVirtual) || 0;

                    formData.visitation.paid.totalPaid = general + school + outOfState + paidOutreachOffsiteVirtual;
                }

                if (key === "complimentary" || key === "recreational" || key === "otherNonTicketed" || key === "outreachOffsiteVirtual") {
                    const complimentary = parseFloat(formData.visitation.unpaid.complimentary) || 0;
                    const recreational = parseFloat(formData.visitation.unpaid.recreational) || 0;
                    const otherNonTicketed = parseFloat(formData.visitation.unpaid.otherNonTicketed) || 0;
                    const outreachOffsiteVirtual = parseFloat(formData.visitation.unpaid.outreachOffsiteVirtual) || 0;

                    formData.visitation.unpaid.totalUnpaid = complimentary + recreational + otherNonTicketed + outreachOffsiteVirtual;

                }
                formData.visitation.totalVisitation = parseFloat(formData.visitation.paid.totalPaid) + parseFloat(formData.visitation.unpaid.totalUnpaid);


                if (key === "phmcAdmissionSharePercent") {
                    const totalAdmissionsRevenue = parseFloat(formData.revenue.totalAdmissionsRevenue) || 0;
                    const associateAdmissionSharePercent = (100 - value);
                    formData.revenue.associateAdmissionSharePercent = associateAdmissionSharePercent;
                    formData.revenue.phmcAdmissionShare = (totalAdmissionsRevenue * (value / 100)).toFixed(2);
                    formData.revenue.associateAdmissionShare = (totalAdmissionsRevenue * (associateAdmissionSharePercent / 100)).toFixed(2);
                }


            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });

        }


    };



    const [saveShow, setSaveShow] = useState(false);

    const handleSaveClose = () => setSaveShow(false);
    const handleSaveShow = (e) => {
        e.preventDefault();
        console.log("save ");
        setSaveShow(true);
    }


    const handleSubmission = (e) => {
        const action = e.target.name;
        console.log(action);
        // closing Modal
        if (action === 'submit') {
            handleSubmitClose();
        }
        if (action === 'save') {
            handleSaveClose();
        }

        setSpinnerShow(true);
        e.preventDefault();
        const datetime = new Date().toISOString();
        formData.updatedDate = datetime;
        formData.updateddBy = userName ? userName : "";
        // Update FiscalYear
        formData.fiscalYear = getFiscalYear(formData.year, formData.month);

        // when trying to save again or submit after save
        if (formData.status === 'DRAFT') {

            if (action === 'save') {
                formData.status = "DRAFT";
            } else if (action === 'submit') {
                formData.status = "SUBMITTED";
            }

            // Call REST API to update the data
            const url = VISITATION_BASE_URL + formData._id + VISITATION_PUT;
            axios.put(url, formData)
                .then((response) => {
                    console.log(response.status, response.data);
                    setSuccessId(response.data._id);
                    setShow(true);
                    setFormData(data);
                    setShowValidationError(false);
                    // Turn off spinner
                    setSpinnerShow(false);

                    if (action === 'save') {
                        setAlertHeading('Saved');
                        setAlertMessage('Visitation Record has been saved!');
                        setPagePath("/visitation");
                    } else if (action === 'submit') {
                        setAlertHeading('Submitted');
                        setAlertMessage('PHMC will review your visitation submission record.');
                        setPagePath("/visitationResponse");
                    }


                }).catch((error) => {
                    console.log(error);
                    setShow(false);
                    setSuccessId('');
                    setAlertHeading('Error');
                    setAlertMessage('Something wrong, Please try again!');
                    // Turn off spinner
                    setSpinnerShow(false);
                });

        } else {
            if (action === 'save') {
                formData.status = "DRAFT";
            } else if (action === 'submit') {
                formData.status = "SUBMITTED";
            }
            formData.createdDate = datetime;
            formData.createdBy = userName ? userName : ""; //user

            // Call REST API to store the data
            const url = VISITATION_BASE_URL + VISITATION_POST;
            axios.post(url, formData)
                .then((response) => {
                    console.log(response.status, response.data);
                    setSuccessId(response.data._id);
                    setShow(true);
                    setFormData(data);
                    setShowValidationError(false);
                    // Turn off spinner
                    setSpinnerShow(false);

                    if (action === 'save') {
                        setAlertHeading('Saved');
                        setAlertMessage('Visitation Record has been saved!');
                        setPagePath("/visitation");
                    } else if (action === 'submit') {
                        setAlertHeading('Submitted');
                        setAlertMessage('PHMC will review your visitation submission record.');
                        setPagePath("/visitationResponse");
                    }

                }).catch((error) => {
                    console.log(error);
                    // reset the status back to empty since api call failed
                    formData.status = "";
                    setShow(false);
                    setSuccessId('');
                    // Turn off spinner
                    setSpinnerShow(false);
                    setAlertHeading('Error');
                    setAlertMessage('Something wrong, Please try again!');
                });
        }

    }
    // reset 
    const handleReset = (e) => {
        console.log('reset ' + new Date().toISOString());
        setFormData(data);
        e.preventDefault();

    }
    // not allow for number fields
    const blockInvalidChar = e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
    // not allow for amount fields
    const blockInvalidAmount = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
    // restrict percent field
    const blockInvalidPercent = e => {

        if (e.target.value > 100) {
            e.target.value = 100;
            e.preventDefault();
            handleInputChange(e);
        }
    }

    const SaveModal = () => {
        return (
            <Modal
                show={saveShow}
                onHide={handleSaveClose}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure, you want to Save! This will not be available for PHMC to review.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSaveClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" name="save" onClick={handleSubmission}>Yes</Button>
                </Modal.Footer>
            </Modal>
        );
    }
    const [submitShow, setSubmitShow] = useState(false);

    const handleSubmitClose = () => setSubmitShow(false);
    const handleSubmitShow = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        console.log('form.checkValidity() :' + form.checkValidity());
        if (form.checkValidity() === false) {
            setShowValidationError(true);
            e.stopPropagation();
        } else {

            setSubmitShow(true);
            setShowValidationError(false);
        }
    }

    const SubmitModal = () => {
        return (
            <Modal
                show={submitShow}
                onHide={handleSubmitClose}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>You will not be able to make changes after submitting the data. Do you want to submit the data entered and notify PHMC?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSubmitClose}> Cancel </Button>
                    <Button variant="primary" name="submit" onClick={handleSubmission}>Yes</Button>
                </Modal.Footer>
            </Modal>
        );
    }
    const [spinnerShow, setSpinnerShow] = useState(false);

    return (
        <>
            <SaveModal />
            <SubmitModal />
            <span ><b>Visitation</b> </span>
            {
                show ? (
                    <Alert variant="success" onClose={() => setShow(false)} dismissible>
                        <Alert.Heading>{alertHeading} Successfully!</Alert.Heading>
                        {/* <Link to={{ pathname: pagePath, search: "?id=" + successId, state: successId }} >{successId}</Link> */}
                        <p>{alertMessage} <Link reloadDocument to={{ pathname: pagePath + "/" + successId, state: successId }} >{successId}</Link> </p>
                    </Alert>

                ) : (<div />)}
            <div className="main-content">
                <Form className="main-content" noValidate validated={showValidationError} onSubmit={handleSubmitShow} >

                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="sitename" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="" name="siteName" required value={formData.siteName} onChange={handleInputChange} >
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select name="year" required value={formData.year} onChange={handleInputChange}>

                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="month">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="" name="month" required value={formData.month} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                    </Row >

                    {/* General Admission Data Entry */}
                    < Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Paid Visitation</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="generalvisitors">
                                            <InfoTooltip label={'General Visitors and Group/Bus Tours'} placement={"right"}>
                                                <Form.Label> General Visitors <FaInfoCircle /></Form.Label>
                                            </InfoTooltip>
                                            <Form.Control type="number" name="visitation.paid.generalVisitors" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.paid?.generalVisitors} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of General Visitors including Group/Bus tours.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                        <Form.Group as={Col} controlId="schoolvisitors">
                                            <Form.Label>School Visitors</Form.Label>
                                            <Form.Control type="number" name="visitation.paid.schoolVisitors" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.paid?.schoolVisitors} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of School Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                    </Row >
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="outofstatevisitors">
                                            <Form.Label>Out of state Visitors</Form.Label>
                                            <Form.Control type="number" name="visitation.paid.outOfStateVisitors" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.paid?.outOfStateVisitors} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of Out Of State Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                        <Form.Group as={Col} controlId="paidOutreachOffsiteVirtual">
                                            <Form.Label>Outreach - Offsite/Virtual </Form.Label>
                                            <Form.Control name="visitation.paid.paidOutreachOffsiteVirtual" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.paid?.paidOutreachOffsiteVirtual} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of paid outreach - offsite and/or virtual visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                    </Row >
                                </Card.Body >
                            </Card >
                        </Col >
                        <Col>
                            {/* Un Paid  Data Entry */}
                            <Card>
                                <Card.Body>
                                    <Card.Title>Un-Paid Visitation</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="complimentary">
                                            <Form.Label>Complimentary</Form.Label>
                                            <Form.Control name="visitation.unpaid.complimentary" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.unpaid?.complimentary} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of Complimentary.
                                            </Form.Control.Feedback>
                                        </Form.Group >

                                        <Form.Group as={Col} controlId="recreational">
                                            <Form.Label>Recreational</Form.Label>
                                            <Form.Control type="number" name="visitation.unpaid.recreational" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.unpaid?.recreational} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of Recreational visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                    </Row >
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="othernonticketed">
                                            <Form.Label>Other Non-ticketed</Form.Label>
                                            <Form.Control name="visitation.unpaid.otherNonTicketed" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.unpaid?.otherNonTicketed} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of Other Non-ticketed visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                        <Form.Group as={Col} controlId="unpaidOutreachOffsiteVirtual">
                                            <Form.Label>Outreach - Offsite/Virtual </Form.Label>
                                            <Form.Control name="visitation.unpaid.outreachOffsiteVirtual" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.unpaid?.outreachOffsiteVirtual} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of unpaid Outreach - Offsite/Virtual visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group >
                                    </Row >
                                </Card.Body >
                            </Card >
                        </Col >
                    </Row >
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Total Visitation</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="totalpaid">
                                            <Form.Label>Total Paid</Form.Label>
                                            <Form.Control disabled type="number" name="visitation.paid.totalPaid" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.paid?.totalPaid} />

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalUnpaid">
                                            <Form.Label>Total UnPaid</Form.Label>
                                            <Form.Control disabled type="number" name="visitation.unpaid.totalUnpaid" required
                                                onKeyDown={blockInvalidChar} value={formData.visitation?.unpaid?.totalUnpaid} />

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="total">
                                            <Form.Label>Total Visitation</Form.Label>
                                            <Form.Control disabled type="number" name="visitation.total" required value={formData.visitation?.totalVisitation} />

                                        </Form.Group>
                                    </Row >
                                </Card.Body >
                            </Card >
                        </Col >
                    </Row >
                    {/* Revenue Entry */}

                    < Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Revenue</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="totalAdmissionsRevenue">
                                            <Form.Label>Total Admissions Revenue</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.totalAdmissionsRevenue" required
                                                    onKeyDown={blockInvalidAmount} value={formData.revenue?.totalAdmissionsRevenue} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the Total Admissions Revenue Amount.
                                                </Form.Control.Feedback>
                                            </InputGroup>

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>PHMC Admissions Percent Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.phmcAdmissionSharePercent" required
                                                    onKeyDown={blockInvalidChar} onKeyUp={blockInvalidPercent} value={formData.revenue?.phmcAdmissionSharePercent} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the PHMC Admissions Percent Split.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>Associate Admissions Percent Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.associateAdmissionSharePercent" disabled value={formData.revenue?.associateAdmissionSharePercent} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>

                                    </Row>
                                    <Row className="mb-3 main-content">
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>PHMC Admissions Share</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.phmcAdmissionShare" disabled value={formData.revenue?.phmcAdmissionShare} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="associateAdmissionShare">
                                            <Form.Label>Associate Admissions Share</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.associateAdmissionShare" disabled value={formData.revenue?.associateAdmissionShare} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Col />
                                    </Row>

                                </Card.Body >
                            </Card >
                        </Col >
                    </Row >
                    {/* TODO: if Partner Property site then hide RR combo and outreach */}
                    {/* RR combo Entry */}
                    {
                        isPartnerProperty ? (
                            <Row className="mb-0 main-content">
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>RR Combo</Card.Title>
                                            <Row className="mb-3 main-content" >
                                                <Form.Group as={Col} controlId="combotixsold">
                                                    <Form.Label>RR Combo TIX Sold</Form.Label>
                                                    <Form.Control type="number" name="combo.tixSold" required
                                                        onKeyDown={blockInvalidChar} value={formData.combo?.tixSold} onChange={handleInputChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter the number of RR Combo TIX Sold.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="combotixrecv">
                                                    <Form.Label>RR Combo TIX RECV</Form.Label>
                                                    <Form.Control name="combo.tixRecv" type="number" required
                                                        onKeyDown={blockInvalidChar} value={formData.combo?.tixRecv} onChange={handleInputChange} />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter the number of RR Combo TIX RECV.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="tixIncome">
                                                    <Form.Label>Combo TIX Income</Form.Label>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text>$</InputGroup.Text>
                                                        <Form.Control type="number" name="combo.tixIncome" required
                                                            onKeyDown={blockInvalidAmount} value={formData.combo?.tixIncome} onChange={handleInputChange} />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter the Combo TIX Income.
                                                        </Form.Control.Feedback>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Row>

                                        </Card.Body>
                                    </Card>
                                </Col>

                            </Row>
                        ) : (<div />)}
                    {/* Associate/Partner Events  */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Event Admissions</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="eventsvisitorspaid">
                                            <Form.Label>Event Paid Visitors</Form.Label>
                                            <Form.Control name="eventsAdmissions.visitorsPaid" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.eventsAdmissions?.visitorsPaid} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of School Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="eventsvisitorsunpaid">
                                            <Form.Label> Event  Unpaid Visitors</Form.Label>
                                            <Form.Control name="eventsAdmissions.visitorsUnPaid" type="number" required
                                                onKeyDown={blockInvalidChar} value={formData.eventsAdmissions?.visitorsUnPaid} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the number of School Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalAssociateEventRevenue">
                                            <Form.Label>Total  Event Revenue</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="eventsAdmissions.totalEventRevenue" required
                                                    onKeyDown={blockInvalidAmount} value={formData.eventsAdmissions?.totalEventRevenue} onChange={handleInputChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    Please enter the number of School Visitors.
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                    </Row >

                                </Card.Body >
                            </Card >
                        </Col >
                    </Row >
                    <Form.Group>


                        <Row className="mb-0 main-content">
                            <Col>
                                <Card>

                                    <Card.Body>
                                        <Card.Title>Remarks</Card.Title>
                                        <Form.Group as={Col} controlId="remarks">

                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Remarks" required name="remarks" value={formData.remarks} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Card.Body>
                                </Card>
                            </Col>

                        </Row>
                        <Row className="mb-0 main-content">
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <Form.Check aria-label="option 1" value={formData.acknowledge} required
                                            label="Did you verify all the data?" />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        {userRole && userRole !== 'OBSERVER' &&
                            <Row className="mb-3 main-content">

                                <Col>
                                    <Row className="mb-3 submit">
                                        <Col>
                                            <Button variant="secondary" onClick={handleReset}>
                                                Reset
                                            </Button>

                                            <Button variant="primary" className="m-1" type="save" onClick={handleSaveShow}>
                                                Save
                                            </Button>

                                            <Button variant="primary" name="submit" type="submit" >
                                                Submit
                                            </Button>

                                        </Col>
                                    </Row>
                                </Col>


                                <Col />
                                <Col />
                                <Col />
                            </Row>
                        }
                        <SpinnerModal show={spinnerShow} onHide={() => setSpinnerShow(false)} />
                    </Form.Group>
                </Form >
            </div >
        </>
    );
}